import CHECK24RAW from './external/mobile.check24.min.js?raw';

try {
    eval.call(window, CHECK24RAW);
} catch (err) {
    console.error(err);
}
try {
    window.C24M.resize.init();
    window.C24M.cookieBanner.init();
    /* EXECUTE COOKIE LOGIC - REMOVE WHEN EVENT IS TRIGGERED THROUGH HOLDING */
    window.TCMS.helper.checkConsentCookie();
} catch (err) {
    console.error(err);
}
